import { api } from './client'
import type { LoginResponse } from './auth'

export interface StaffInviteInfo {
  status: 'pending' | 'used' | 'expired' | 'unknown'
  club: {
    id: number
    name: string
    logo_url: string | null
    primary_color: string | null
  }
  club_role: 'manager'
  email: string | null
  /** El mail invitado ya es un usuario: hay que aceptar con sesión, no dar de alta. */
  account_exists: boolean
  expires_at: string
}

export interface StaffInviteAccepted {
  club: { id: number; name: string }
  club_role: 'manager'
}

export const staffInvite = {
  resolve: (token: string) =>
    api.get<StaffInviteInfo>(`/staff-invites/${encodeURIComponent(token)}`),

  /** Aceptar con la cuenta que ya está logueada (el otro camino es `register`). */
  accept: (token: string) =>
    api.post<StaffInviteAccepted>(
      `/staff-invites/${encodeURIComponent(token)}/accept`,
      {},
    ),

  register: (
    token: string,
    payload: { email: string; password: string; display_name?: string },
  ) =>
    api.post<LoginResponse>(
      `/staff-invites/${encodeURIComponent(token)}/register`,
      payload,
    ),
}
